// Development / debugging affordances

import { SozDB } from "./db";
import { RoomsDB } from "./db/roomsDB";

declare const globalThis: any;

globalThis.SozDB = SozDB;
globalThis.RoomsDB = RoomsDB;
